import styled from 'styled-components';
import tw from 'twin.macro';
import Carousel from 'brainhubeu-react-carousel';
import { GroupWrap } from 'components/group-wrap/group-wrap';

export const LeftColumn = styled.div`
  ${tw`flex items-start pt-8 pb-8`};
  height: 100%;
  min-height: 100%;
  flex: 1;
`;
export const RightColumn = styled.div`
  ${tw`flex pt-8 pb-8 pl-8`};
  flex: 1;
`;
export const AdPlaceholder = styled.div`
  width: 430px;
`;

export const ReportOfferWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
`;

export const StyledSlider = styled(Carousel)<any>`
  max-height: ${({ min1024 }) => (min1024 ? '370px' : '320px')};
  position: relative;
  & .BrainhubCarousel__customArrows {
    cursor: pointer;
    position: absolute;
    z-index: 1;
    left: 16px;
    &.BrainhubCarousel__custom-arrowLeft:nth-of-type(3) {
      left: auto;
      right: 16px;
    }
  }
`;

export const CounterGallery = styled.div<any>`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  padding: 0 6px;
  right: ${({ min1024 }) => (min1024 ? '16px' : '8px')};
  bottom: ${({ min1024 }) => (min1024 ? '16px' : '8px')};
`;

export const WrapperGallery = styled.div<any>`
  max-height: ${({ min1024 }) => (min1024 ? '370px' : '320px')};
  width: 100%;
  overflow: hidden;
  position: relative;
`;

export const RatingWrapper = styled(GroupWrap)`
  margin-bottom: 14px;
  width: 100%;
`;
